import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    height: "80%",
    margin: 0,
  },
  listBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #4DD0E1",
    borderRadius: "3px",
  },
  header: {
    padding: theme.spacing(1),
    display: "flex",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
  },
  headerItem: {
    margin: "0 10px",
  },
  listContainer: {
    flexGrow: 1,
    overflowY: "auto",
  },
}));

export default function DropdownListForOrderUser({
  userList,
  setUsername,
  setUsernumber,
  setUserdepnumber,
  setUserdepname,
  setEmail,
  setRole,
}) {
  const [personName, setPersonName] = React.useState([]);
  const classes = useStyles();
  const handleToggle = (value) => {
    const currentIndex = personName.indexOf(value[0]);
    setPersonName(value[0]);
    if (value[0].includes("エラー")) {
      setUsernumber("");
      setUsername("");
      setUserdepnumber("");
      setUserdepname("");
      setEmail("");
    } else {
      setUsernumber(value[0]);
      setUsername(value[1]);
      setUserdepnumber(value[2]);
      setUserdepname(value[3]);
      setEmail(value[4]);
    }
  };

  return (
    <FormControl className={classes.formControl}>
      <div className={classes.listBox}>
        {/* Header */}
        <div className={classes.header}>
          <div className={classes.headerItem}>
            <Typography variant="subtitle1">社員番号</Typography>
          </div>
          <div className={classes.headerItem}>
            <Typography variant="subtitle1">氏名</Typography>
          </div>
        </div>
        <List className={classes.listContainer}>
          {userList.map((user) => {
            const labelId = `checkbox-list-label-${user[0]}`;
            //const userValue = user.join(',');
            //console.log("userValue", user);
            return (
              <ListItem
                key={user[0]}
                role={undefined}
                dense
                button
                onClick={() => handleToggle(user)}
              >
                {
                  <Checkbox
                    edge="start"
                    checked={personName.indexOf(user[0]) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                }
                <ListItemText
                  id={labelId}
                  primary={
                    user[0].padStart(5, 0) +
                    ":" +
                    user[1] +
                    " : " +
                    user[4].split("@")[0]
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </FormControl>
  );
}
